import '@splidejs/react-splide/css';
import {Splide, SplideSlide} from '@splidejs/react-splide';

import {styled} from '@volkswagen-onehub/components-core';
import React from 'react';
import {ModelImage} from '../../types/models';

interface ResultGalleryInterface {
  images: ModelImage[];
}

const ResultGalleryContainer = styled.div`
  flex: 1;

  img {
    width: 100%;
  }

  .splide__slide {
    opacity: 0.5;
  }

  .splide__slide.is-active {
    transition: opacity 0.1s ease, transform 0.1s ease;
    opacity: 1;
  }

  .splide__arrow {
    opacity: 1;
    border: 2px solid rgb(0, 30, 80);
    background-color: #001e50;
    height: 45px;
    width: 45px;

    svg {
      fill: #fff;
    }

    &.splide__arrow--next {
      svg {
        margin-top: 15px;
        margin-left: 15px;
        transform: scale(2);
      }
    }

    &.splide__arrow--prev {
      /* display: none; */

      svg {
        margin-right: 15px;
        margin-bottom: 13px;
        transform: scale(2) rotate(180deg);
      }
    }
  }
`;

const ResultGallery: React.FC<ResultGalleryInterface> = ({images}) => {
  return (
    <ResultGalleryContainer>
      <Splide
        aria-label="My Favorite Images"
        options={{
          type: 'slide',
          gap: '2rem',
          pagination: false,
          arrows: true,
          padding: {right: '20%'},
          arrowPath:
            'm17.5 5.999-.707.707 5.293 5.293H1v1h21.086l-5.294 5.295.707.707L24 12.499l-6.5-6.5z',
        }}
      >
        {images.map((image) => (
          <SplideSlide key={image.url}>
            <img src={image.url} alt={image.alt} />
          </SplideSlide>
        ))}
      </Splide>
    </ResultGalleryContainer>
  );
};

export default ResultGallery;
